import routerOptions0 from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7_supports-color@1_442477e22c1d0e45cc8f50a790870a47/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}